/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterSovQueryDto
 */
export interface FilterSovQueryDto {
    /**
     * 
     * @type {string}
     * @memberof FilterSovQueryDto
     */
    submissionId: string;
    /**
     * 
     * @type {string}
     * @memberof FilterSovQueryDto
     */
    searchText?: string;
}

/**
 * Check if a given object implements the FilterSovQueryDto interface.
 */
export function instanceOfFilterSovQueryDto(value: object): value is FilterSovQueryDto {
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function FilterSovQueryDtoFromJSON(json: any): FilterSovQueryDto {
    return FilterSovQueryDtoFromJSONTyped(json, false);
}

export function FilterSovQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterSovQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'submissionId': json['submissionId'],
        'searchText': json['searchText'] == null ? undefined : json['searchText'],
    };
}

export function FilterSovQueryDtoToJSON(json: any): FilterSovQueryDto {
    return FilterSovQueryDtoToJSONTyped(json, false);
}

export function FilterSovQueryDtoToJSONTyped(value?: FilterSovQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submissionId': value['submissionId'],
        'searchText': value['searchText'],
    };
}

